import {dicts} from "../../plugins/dict.js";
import i18nKit from "../../plugins/I18N.js"
let i18n = i18nKit.methods;
// import kit from "../../plugins/kit.js"
// let api = kit.api;

const columns =  [
    {field: 'id', title:i18n.msg('ID')},
    {field: 'created', title:i18n.msg('录单时间')},
    {field: 'status', title:i18n.msg('采购状态')},
    {field: 'expCode', title:i18n.msg('快递单号')},
    {field: 'purchaseCode', title:i18n.msg('采购单号')},
    {field: 'title', title:i18n.msg('产品名称')},
    {field: 'spec', title:i18n.msg('规格')},
    {field: 'sku', title:i18n.msg('SKU')},
    {field: 'variationSku', title:i18n.msg('货号')},
    {field: 'qty', title:i18n.msg('采购件数')},
    {field: 'totalAmount', title:i18n.msg('采购单价')},
    {field: 'price', title:i18n.msg('采购金额')},
    {field: 'origin', title:i18n.msg('采购平台')},
    {field: 'inCode', title:i18n.msg('补货单号')},
    {field: 'days', title:i18n.msg('配送天数')},
    {field: 'storeName', title:i18n.msg('到货仓库')},
    {field: 'receiveDate', title:i18n.msg('签收时间')},
    {field: 'ownerName', title:i18n.msg('归属人')},
    {field: 'ownerCompanyName', title:i18n.msg('归属公司')},
    {field: 'refuse', title:i18n.msg('是否拒收')},
    {field: 'remark1', title:i18n.msg('说明')},
    {field: 'remark', title:i18n.msg('备注')}
];

const expColumns =  [
    {field: 'id', title:i18n.msg('ID')},
    {field: 'created', title:i18n.msg('录单时间')},
    {field: 'status', title:i18n.msg('采购状态')},
    {field: 'expCode', title:i18n.msg('快递单号')},
    {field: 'purchaseCode', title:i18n.msg('采购单号')},
    {field: 'storeName', title:i18n.msg('到货仓库')},
    {field: 'receiveDate', title:i18n.msg('签收时间')},
    {field: 'ownerName', title:i18n.msg('归属人')},
    {field: 'ownerCompanyName', title:i18n.msg('归属公司')},
    {field: 'refuse', title:i18n.msg('是否拒收')},
];

const doBuildColumns = function(h, vue, cols){
    let allColumns = [
        {type: 'checkbox', minWidth: 50 ,fixed: 'left'},
        {field: 'id', title:i18n.msg('ID'), minWidth: 100, sortable: true,
            slots: {
                default: ({row}) => {
                    return [<span>
                        <el-link underline={false} style="margin-right:4px; font-size:12px "
                            onClick={()=> vue.$refs.InvinventoryInEditRef.showDialog(2, row, vue.stores)} 
                        >
                            <i style="margin-right:4px; font-size:12px;" class="iconfont icon-edit"></i>
                        </el-link>
                        {row.id}
                    </span>]
                }
            }
        },
        {field: 'created', title:i18n.msg('录单时间'), minWidth: 120, sortable: true,
            filters: [{data: []}],
            filterRender:  {
                name: 'ElDatePicker', 
                props: {
                    type: 'daterange', 
                    rangeSeparator: '至', startPlaceholder: '开始日期', 
                    endPlaceholder: '结束日期'
                }
            },
        },
        {field: 'status', title:i18n.msg('采购状态'), minWidth: 80, sortable: true, 
            slots: {
                default: ({row}) => {
                    let status = dicts.inventoryInStatus.find(d => d.value === row.status);
                    if(status){
                        return [
                            <el-tag type={status.type} effect="plain" style="cursor:pointer;"
                                onClick={()=> vue.$refs.inventoryInTraceRef.showTracks(row.id, row.purchaseCode, row.expCode)} 
                            >
                                { status.label}
                            </el-tag>
                        ];
                    }else{
                        return row.status;
                    }
                }
            },
            formatter: ({row}) => {
                let status = dicts.inventoryInStatus.find(d => d.value === row.status);
                return status?status.label:row.status;
            },
            filters:dicts.inventoryInStatus,
        },
        {field: 'expCode', title:i18n.msg('快递单号'), minWidth: 120, sortable: true,
            slots: {
                default: ({row}) => {
                    return [
                        <div>
                            <i class="status-cell iconfont icon-trace font11"></i>
                            {row.expCode?
                                (
                                <span>
                                <a target="_blank" href={'https://www.baidu.com/s?wd='+row.expCode}><i class="el-icon-link"></i></a>
                                {row.expCode}
                                </span>
                                )
                                :
                                ""
                            }
                        </div>
                    ]
                }
            },
            filters:[{data: null}],
            filterRender:{name: 'FilterInput'}
        },
        {field: 'purchaseCode', title:i18n.msg('采购单号'), minWidth: 120, sortable: true,
            filters:[{data: null}],
            filterRender:{name: 'FilterInput'}
        },
        {field: 'title', title:i18n.msg('产品名称'), minWidth: 150, sortable: true,
            filters:[{data: null}],
            filterRender:{name: 'FilterInput'}
        },
        {field: 'spec', title:i18n.msg('规格'), minWidth: 120, sortable: true,
            filters:[{data: null}],
            filterRender:{name: 'FilterInput'}    
        },
        {field: 'sku', title:i18n.msg('SKU'), minWidth: 120, sortable: true,
            filters:[{data: null}],
            filterRender:{name: 'FilterInput'}    
        },
        {field: 'variationSku', title:i18n.msg('货号'), minWidth: 120, sortable: true,
            filters:[{data: null}],
            filterRender:{name: 'FilterInput'}
        },
        {field: 'qty', title:i18n.msg('采购件数'), minWidth: 80, sortable: true},
        {field: 'totalAmount', title:i18n.msg('采购单价'), minWidth: 80, sortable: true, 
            slots: {
                default: ({row}) => {
                    let price = row.price || 0, qty = row.qty || 1;
                    return (price*0.01 / qty) .toFixed(2);
                }
            },
            formatter: ({row, cellValue}) => {
                let price = row.price || 0, qty = row.qty || 1;
                return (price*0.01 / qty) .toFixed(2);
            }
        },
        {field: 'price', title:i18n.msg('采购金额'), minWidth: 80, sortable: true, 
            slots: {
                default: ({row}) => {
                    let price = row.price || 0;
                    return (price*0.01).toFixed(2)
                }
            },
            formatter: ({row}) => {
                let price = row.price || 0;
                return (price*0.01).toFixed(2)
            }
        },
        {field: 'origin', title:i18n.msg('采购平台'), minWidth: 80, sortable: true, 
            slots: {
                default: ({row}) => {
                    let link = row.link;
                    let origin = dicts.productOrigin.find(d => d.value === row.origin);
                    if(link || origin){
                        return [
                        <span>
                        {link?<el-link href={link} target="_blank" icon="el-icon-link"></el-link>:''}
                        <el-tag size="mini" type={origin?origin.type:''}>{origin?origin.label:''}</el-tag>
                        </span>
                        ]
                    }else{
                        return origin;
                    }
                }
            },
            filters:dicts.productOrigin,
            formatter:this.formatOrigin
        },
        {field: 'inCode', title:i18n.msg('补货单号'), minWidth: 80, sortable: true,
            filters:[{data: null}],
            filterRender:{name: 'FilterInput'}
        },
        {field: 'days', title:i18n.msg('配送天数'), minWidth: 65, sortable: true, 
            slots: {
                default: ({row}) => {
                    let status = row.status;
                    let sendDate = row.sendDate;
                    if(status == 10 && sendDate){  //已发货
                        let prevDate = new Date(sendDate);
                        let curr = new Date();
                        let day = Math.trunc((curr - prevDate) / (3600*24*1000));
                        return day;
                    }else{
                        return "";
                    }
                }
            },
            formatter: ({row}) => {
                let status = row.status;
                let sendDate = row.sendDate;
                if(status == 10 && sendDate){  //已发货
                    let prevDate = new Date(sendDate);
                    let curr = new Date();
                    let day = Math.trunc((curr - prevDate) / (3600*24*1000));
                    return day;
                }else{
                    return "";
                }
            }
        },
        {field: 'storeName', title:i18n.msg('到货仓库'), minWidth: 120, sortable: true,
            filters: [{data: {vals: [], sVal: '', my: "t_stock"}}],
            filterRender:  {name: 'StockFilterContent'}
        },
        {field: 'receiveDate', title:i18n.msg('签收时间'), minWidth: 120, sortable: true,
            filters: [{data: []}],
            filterRender:  {
                name: 'ElDatePicker', 
                props: {
                    type: 'daterange', 
                    rangeSeparator: '至', startPlaceholder: '开始日期', 
                    endPlaceholder: '结束日期'
                }
            },
        },
        {field: 'ownerName', title:i18n.msg('归属人'), minWidth: 120, sortable: true,
            filters: [{data: {vals: [], sVal: '', my: "t_stock"}}],
            filterRender:  {name: 'StockFilterContent'}
        },
        {field: 'ownerCompanyName', title:i18n.msg('归属公司'), minWidth: 120, sortable: true,
            filters: [{data: {vals: [], sVal: '', my: "t_stock"}}],
            filterRender:  {name: 'StockFilterContent'}
        },
        {field: 'refuse', title:i18n.msg('是否拒收'), minWidth: 120, sortable: true,
            filters:[{data: null}],
            filterRender:{name: 'FilterInput'}
        },
        {field: 'remark1', title:i18n.msg('说明'), minWidth: 120, sortable: true,
            filters:[{data: null}],
            filterRender:{name: 'FilterInput'}
        },
        {field: 'remark', title:i18n.msg('备注'), minWidth: 120, sortable: true,
            filters:[{data: null}],
            filterRender:{name: 'FilterInput'}
        }
    ];

    let showCols = [
        {type: 'checkbox', minWidth: 40, fixed: "left", align:"center"}
    ]

    if(cols && cols.length>0){
        cols.forEach(f => {
            let col = allColumns.find(c => c.field == f.field);
            if(col){
                showCols.push(col);
            }
        });
    }else{
        allColumns.forEach(col => showCols.push(col));
    }
    // let columnsStr = localStorage.getItem("order-columns")
    return showCols;

}

export default {
    allColumns: columns,
    allExpColumns: expColumns,
    buildColumns : doBuildColumns
}

